import Strategy from './views/Strategy'
import StrategyForm from './views/StrategyForm'
import Users from './views/Users'
import UserForm from './views/UserForm'
import ApiKeys from './views/ApiKeys'
import ApiKeysForm from './views/ApiKeysForm'
import StrategyDeals from './views/StrategyDeals'
import UserProfile from './views/UserProfile'
import { isAdmin, isUser, isWatchdog } from './helpers/roles'
import DealsForms from "./views/DealsForms";
import ApiKeysOrdersForm from './views/ApiKeysOrderForm'
import BalancesWS from 'views/BalancesWS'

var routes = [
  {
    path: '/strategy',
    name: 'sidebar.strategies',
    icon: 'fa-solid fa-chart-line',
    component: <Strategy />,
    layout: '/admin',
    showInSideBar: isAdmin() || isUser() || isWatchdog(),
  },
  {
    path: '/strategy/add',
    name: 'sidebar.strategyAdd',
    icon: 'tim-icons icon-sound-wave',
    component: <StrategyForm />,
    layout: '/admin',
    showInSideBar: false,
  },
  {
    path: '/strategy/edit/:id',
    name: 'sidebar.strategyEdit',
    icon: 'tim-icons icon-sound-wave',
    component: <StrategyForm />,
    layout: '/admin',
    showInSideBar: false,
  },
  {
    path: '/strategy/deals/:strategyId',
    name: 'sidebar.strategyAdd',
    icon: 'tim-icons icon-sound-wave',
    component: <StrategyDeals />,
    layout: '/admin',
    showInSideBar: false,
  },
  {
    path: '/apikeys',
    name: 'sidebar.apikeys',
    icon: 'fa fa-key',
    component: <ApiKeys />,
    layout: '/admin',
    showInSideBar: isAdmin() || isUser(),
  },
  {
    path: '/apikeys/add',
    name: 'sidebar.apikeysAdd',
    icon: 'fa fa-key',
    component: <ApiKeysForm />,
    layout: '/admin',
    showInSideBar: false,
  },
  {
    path: '/apikeys/edit/:id',
    name: 'sidebar.apikeysEdit',
    icon: 'fa fa-key',
    component: <ApiKeysForm />,
    layout: '/admin',
    showInSideBar: false,
  },
  {
    path: '/apikeys/edit/:id/orders',
    name: 'Api Keys Orders',
    icon: 'fa fa-key',
    component: <ApiKeysOrdersForm />,
    layout: '/admin',
    showInSideBar: false,
  },
  {
    path: '/deals',
    name: 'sidebar.deals',
    icon: 'fa-solid fa-scale-unbalanced-flip',
    component: <DealsForms />,
    layout: '/admin',
    showInSideBar: isAdmin() || isUser() ,
  },
  {
    path: '/users',
    name: 'sidebar.users',
    icon: 'fa fa-user',
    component: <Users />,
    layout: '/admin',
    showInSideBar: isAdmin(),
  },
  {
    path: '/user/add',
    name: 'sidebar.usersAdd',
    icon: 'tim-icons fa fa-user',
    component: <UserForm />,
    layout: '/admin',
    showInSideBar: false,
  },
  {
    path: '/user/edit/:id',
    name: 'sidebar.usersEdit',
    icon: 'tim-icons fa fa-user',
    component: <UserForm />,
    layout: '/admin',
    showInSideBar: false,
  },
  {
    path: '/user/profile',
    name: 'sidebar.usersProfile',
    icon: 'tim-icons fa fa-user',
    component: <UserProfile />,
    layout: '/admin',
    showInSideBar: false,
  },
  {
    path: '/user/balances',
    name: 'sidebar.balances',
    icon: 'tim-icons fa icon-coins',
    component: <BalancesWS />,
    layout: '/admin',
    showInSideBar: isAdmin() || isUser() || isWatchdog(),
  },
]
export default routes
